import { Employer, Realtor } from '~/models'
import { $axios } from '~/utils/api'

const getLookupOptions = (
  search: string = '',
  lookupEntity: string = ''
): Promise<Array<Employer | Realtor>> => {
  return $axios.$get(`/${lookupEntity}?startswith=${search}`)
}

export { getLookupOptions }
